var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p404"},[_c('div',{staticClass:"content"},[_c('strong',[_vm._v("404")]),_c('p',[_vm._v("UH OH! 页面不存在")]),_c('span',[_vm._v(_vm._s(_vm.time)+"s 返回首页")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("立即返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }